RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PdfPanel = RivalIQ.apps.Dashboard.views.PdfPanel.extend({
        loadData: function () {
            const me = this;
            return App.utils.fetchCompanyData().done(function (companyData) {
                me.dashboardModel.companyData = companyData;
            });
        }
    });
});
